import Vue from "vue";
import Vuex from "vuex";

import * as user from "@/store/modules/user.js";
import * as monday from "@/store/modules/monday.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    is_loading: false
  },
  mutations: {
    SET_IS_LOADING(state, is_loading) {
      state.is_loading = is_loading;
    }
  },
  actions: {
    setIsLoading({ commit, dispatch }, is_loading) {
      commit("SET_IS_LOADING", is_loading);
    }
  },
  modules: {
    user,
    monday
  }
});
